import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as authActions } from "../store/modules/auth";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { hash } from "../lib/common";
import icon from "../image/icon.png";
import Grid from "@material-ui/core/Grid";
import { withTranslation } from "react-i18next";

const styles = theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    width: 60,
    height: 60
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  button: {
    margin: theme.spacing(1),
  }
});

class Home extends Component {
  constructor(props) {
    super(props);
  }

  handleNext = () => {
    // const hexId = new Buffer(this.props.id).toString('hex')
    const hex = hash(this.props.id);
    this.props.history.push("/@" + hex);
  };

  handleKeyPress = e => {
    // 눌려진 키가 Enter 면 handleCreate 호출
    if (e.key === "Enter") {
      this.handleNext();
    }
  };

  handleChange = e => {
    const { authActions } = this.props;
    authActions.setPhoneInput(e.target.value);
  };

  changeLanguage = lng => {
    this.props.i18n.changeLanguage(lng);
  };

  render() {
    const { id, t, i18n } = this.props;
    const lang = i18n.language; 
    const classes = this.props.classes;

    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar} src={icon} />
          <Typography component="h1" variant="h5">
            First stamp
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="phone"
              label="Phone"
              name="phone"
              type="number"
              value={id}
              onChange={this.handleChange}
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={this.handleNext}
            >
              {t("home_btn")}
            </Button>
          </form>
        </div>
        <Grid container justify="center">
          <Grid item>
            <Button disabled={lang == 'ko'} className={classes.button} onClick={() => this.changeLanguage('ko')}>
              KOR
            </Button>
          </Grid>
          <Grid item>
            <Button disabled={lang == 'en'} className={classes.button} onClick={() => this.changeLanguage('en')}>
              ENG
            </Button>
          </Grid>
        </Grid>
        <Box mt={5} />
      </Container>
    );
  }
}

export default connect(
  state => ({
    id: state.auth.id
  }),
  dispatch => ({
    authActions: bindActionCreators(authActions, dispatch)
  })
)(withStyles(styles)(withTranslation()(Home)));
